import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { apiPut } from '../../../utils/apiFetch'
import apiPath from '../../../utils/pathObj'
import useToastContext from 'hooks/useToastContext'
import Swal from 'sweetalert2'

const RequestAccept = ({
  setJobRequest,
  setPage,
  allRequest,
  currentItem,
  jobApply
}) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const { handleSubmit } = useForm({ mode: 'onChange' })
  const onSubmit = async () => {
    try {
      // 1. SweetAlert Confirmation Popup
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You are about to accept this candidate. This action cannot be undone.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, accept it!'
      })

      if (!result.isConfirmed) return

      // 2. API Call - ONLY changing status to 'accepted'
      const payload = {
        employeeID: currentItem.Employee._id,
        status: 'accepted'
      }

      const res = await apiPut(
        apiPath.ChangeStatusJob + '/' + currentItem._id,
        payload
      )

      if (res?.data?.success) {
        allRequest()
        setPage(1)
        setJobRequest(false) // Close the parent state that opened this component

        // 3. SweetAlert Success + Instruction to move to Interview
        await Swal.fire({
          icon: 'success',
          title: 'Accepted Successfully!',
          text: 'Now please proceed to the Interview Management tab to assign forms and schedule the interview.',
          confirmButtonColor: '#3085d6',
        })
        
        notification.success(res?.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong while accepting the candidate.',
      })
    }
  }

  // We use useEffect to immediately trigger the popup when this component loads
  React.useEffect(() => {
    handleSubmit(onSubmit)();
  }, []);

  // Return null because this component doesn't render any HTML, it only shows modals
  return null;
}

export default RequestAccept